import { useEffect, useState } from 'react';

const pad = (value: number) => value.toString().padStart(2, '0');

export function useCountdownTo(targetHour: number, targetMinute: number) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const compute = () => {
      const now = new Date();
      const target = new Date(now);
      target.setHours(targetHour, targetMinute, 0, 0);
      if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }
      return target.getTime() - now.getTime();
    };

    setRemaining(compute());
    const timer = window.setInterval(() => {
      setRemaining(compute());
    }, 1000);

    return () => window.clearInterval(timer);
  }, [targetHour, targetMinute]);

  const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    label: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    isToday: new Date().getHours() < targetHour,
  };
}